import Masonry from "masonry-layout";
import debounce from "./debounce";

var msnry;

const brand_cards = () => {
  const grid = document.querySelectorAll('.brand-cards .grid');
  if(grid.length) {
    msnry = new Masonry(".brand-cards .grid", {
      itemSelector: ".card",
      percentPosition: true,
      gutter: 20,
      resize: true,
    });
  }

  $(window).on("resize",
    debounce(function () {
      if (msnry) {
        msnry = new Masonry(".brand-cards .grid", {
          itemSelector: ".card",
          percentPosition: true,
          gutter: 20,
          resize: true,
        });
      }
    }, 250)
  );
};

export default brand_cards;
